type APIResponse = { status: "failure" | "success"; message?: string };

const call = async (data: object): Promise<APIResponse> => {
  try {
    const res = await fetch("/api/user/opt-out", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    const json = (await res.json()) as { success: boolean; message?: string };
    return { status: json.success ? "success" : "failure", message: json.message };
  } catch (error) {
    console.error(error);
    return { status: "failure", message: "an unexpected error occurred" };
  }
};

export const requestOptOut = (email: string) =>
  call({ action: "create", email });

export const resendOptOutEmail = (email: string) =>
  call({ action: "resend", email });

export const verifyOptOut = (code: string) =>
  call({ action: "verify", code });

export const cancelOptOut = (code: string) =>
  call({ action: "cancel", code });
